<script lang="ts">
	import type { CmsFlowContentRecord } from '$lib/data/types';
	import { getCmsTranslationForLocale } from '$lib/cms';
	import { locale } from 'svelte-i18n';

	export let data: CmsFlowContentRecord | undefined = undefined;
	export let noStyles = false;
</script>

{#if data}
	{@const translation = getCmsTranslationForLocale(data.translations, $locale)}
	{#if noStyles}
		{@html translation.body}
	{:else}
		<div class="row mt-2">
			<div class="col-12">
				{@html translation.body}
			</div>
		</div>
	{/if}
{/if}
